import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CloseButtonComponent } from './close-button.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        CloseButtonComponent,
    ],
    exports: [
        CloseButtonComponent
    ]
})

export class CloseButtonModule { }
